/**
 * Shared responsive tokens.
 *
 * Before this file, breakpoints were invented ad-hoc per page (600 / 768 / 960 /
 * 1200 / 1280 all appeared in different `styles.ts` files, and most pages had
 * none at all). Import from here so every screen breaks at the same widths.
 */
export const breakpoints = {
  xs: 480, // small phones
  sm: 600, // phones
  md: 900, // tablets — this is where the sidebar becomes an overlay drawer
  lg: 1200, // small laptops
  xl: 1440, // desktops
};

/** `[down.md]: { ... }` — styles applied at or below a breakpoint. */
export const down = {
  xs: `@media (max-width: ${breakpoints.xs}px)`,
  sm: `@media (max-width: ${breakpoints.sm}px)`,
  md: `@media (max-width: ${breakpoints.md}px)`,
  lg: `@media (max-width: ${breakpoints.lg}px)`,
  xl: `@media (max-width: ${breakpoints.xl}px)`,
};

/** `[up.md]: { ... }` — styles applied above a breakpoint. */
export const up = {
  xs: `@media (min-width: ${breakpoints.xs + 1}px)`,
  sm: `@media (min-width: ${breakpoints.sm + 1}px)`,
  md: `@media (min-width: ${breakpoints.md + 1}px)`,
  lg: `@media (min-width: ${breakpoints.lg + 1}px)`,
  xl: `@media (min-width: ${breakpoints.xl + 1}px)`,
};

/** Pointer-based query: true on touch devices, where hover styles are useless. */
export const hoverOnly = "@media (hover: hover) and (pointer: fine)";

/** Respect the OS "reduce motion" setting. */
export const reducedMotion = "@media (prefers-reduced-motion: reduce)";

/** Layout constants shared by the sidebar and every page shell. */
export const layout = {
  /** Icon-only sidebar width (desktop default). */
  sidebarRail: 72,
  /** Expanded sidebar width, with labels. */
  sidebarExpanded: 240,
  /** Height of the mobile top bar that holds the hamburger. */
  mobileBarHeight: 56,
};

export default breakpoints;
